import { render, staticRenderFns } from "./MemoryHero.vue?vue&type=template&id=0ebfb634&scoped=true"
import script from "./MemoryHero.vue?vue&type=script&lang=js"
export * from "./MemoryHero.vue?vue&type=script&lang=js"
import style0 from "./MemoryHero.vue?vue&type=style&index=0&id=0ebfb634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebfb634",
  null
  
)

export default component.exports